<template>
  <component :is="layout">
    <transition name="fade" mode="out-in">
      <router-view />
    </transition>
  </component>
</template>

<script>
import DefaultLayout from "@/layouts/default";
import AppLayout from "@/layouts/app";

import AOS from "aos";
import "aos/dist/aos.css";

export default {
  name: "App",
  components: {
    DefaultLayout,
    AppLayout,
  },
  computed: {
    layout() {
      return `${this.$route.meta.layout || "default"}-layout`;
    },
  },
  mounted() {
    AOS.init({
      offset: 60,
      duration: 1200,
    });
  },
};
</script>

<style></style>
